import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEyeSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eye-sparkle, magic eyes"><path d="M2 11.9999C6.82745 2.33329 17.1725 2.3334 22 12C17.1725 21.6666 6.82745 21.6665 2 11.9999Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M12.4 8H11.6L10.6 10.6L8 11.6V12.4L10.6 13.4L11.6 16H12.4L13.4 13.4L16 12.4V11.6L13.4 10.6L12.4 8Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEyeSparkle;
